import { motion } from "framer-motion";
import { Clock, MapPin, MessageCircle, UtensilsCrossed, Instagram } from "lucide-react";
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY, MAPS_URL, IFOOD_URL, INSTAGRAM_URL, STORE_HOURS_WEEK, STORE_HOURS_SUNDAY, STORE_ADDRESS, IMAGES } from "../data/menu";
import { Chapter } from "./Chapter";

export const StoreInfo = () => (
  <div>
    <Chapter number="04" title="A loja" accent="#06B6D4">
      Passe para retirar, peça para entregar ou chame no WhatsApp. Estamos
      te esperando com o copo mais giga da cidade.
    </Chapter>

    <div className="grid items-stretch gap-10 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="relative overflow-hidden rounded-[2rem] border border-purple-500/25"
      >
        <img
          src={IMAGES.preparo}
          alt="Preparo artesanal do açaí com caldas"
          className="h-full min-h-[320px] w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1E053B]/20" />
        <div className="absolute bottom-6 left-6 rounded-2xl border border-purple-400/30 bg-[#1E053B]/80 px-5 py-3 backdrop-blur-xl">
          <p className="font-syne text-lg font-extrabold text-white">
            Feito na hora, do seu jeito
          </p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="flex flex-col justify-center gap-5 rounded-[2rem] border border-purple-500/25 bg-[#2D0B5A]/70 p-8 backdrop-blur-xl sm:p-10"
      >
        <div className="flex items-start gap-4" data-testid="store-hours">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cyan-400/15 text-cyan-300">
            <Clock className="h-5 w-5" />
          </span>
          <div>
            <p className="font-grotesk text-xs font-bold uppercase tracking-[0.25em] text-purple-300/70">
              Horário de funcionamento
            </p>
            <p className="mt-1.5 font-syne text-xl font-bold text-white">{STORE_HOURS_WEEK}</p>
            <p className="mt-1 font-syne text-xl font-bold text-white">{STORE_HOURS_SUNDAY}</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-400/15 text-emerald-300">
            <MessageCircle className="h-5 w-5" />
          </span>
          <div className="flex-1">
            <p className="font-grotesk text-xs font-bold uppercase tracking-[0.25em] text-purple-300/70">
              WhatsApp da loja
            </p>
            <a
              data-testid="store-whatsapp-link"
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Olá Giga Açaí! Quero fazer um pedido.")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-emerald-400 px-6 py-3 font-grotesk text-sm font-bold uppercase tracking-[0.12em] text-[#1E053B] transition-transform duration-300 hover:scale-[1.04] active:scale-95"
            >
              {WHATSAPP_DISPLAY}
            </a>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-red-500/15 text-red-400">
            <UtensilsCrossed className="h-5 w-5" />
          </span>
          <div className="flex-1">
            <p className="font-grotesk text-xs font-bold uppercase tracking-[0.25em] text-purple-300/70">
              Também estamos no iFood
            </p>
            <a
              data-testid="store-ifood-link"
              href={IFOOD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#EA1D2C] px-6 py-3 font-grotesk text-sm font-bold uppercase tracking-[0.12em] text-white transition-transform duration-300 hover:scale-[1.04] active:scale-95"
            >
              Pedir pelo iFood
            </a>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-pink-500/15 text-pink-400">
            <Instagram className="h-5 w-5" />
          </span>
          <div className="flex-1">
            <p className="font-grotesk text-xs font-bold uppercase tracking-[0.25em] text-purple-300/70">
              Instagram da loja
            </p>
            <a
              data-testid="store-instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-2 rounded-full border border-pink-400/40 px-6 py-3 font-grotesk text-sm font-bold uppercase tracking-[0.12em] text-pink-300 transition-colors duration-300 hover:bg-pink-500 hover:text-white"
            >
              @gigaacaioficial
            </a>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400/15 text-amber-300">
            <MapPin className="h-5 w-5" />
          </span>
          <div className="flex-1">
            <p className="font-grotesk text-xs font-bold uppercase tracking-[0.25em] text-purple-300/70">
              Onde estamos
            </p>
            <p className="mt-1.5 text-sm font-semibold text-white" data-testid="store-address">
              {STORE_ADDRESS}
            </p>
            <a
              data-testid="store-maps-link"
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-2 rounded-full border border-purple-400/40 px-6 py-3 font-grotesk text-sm font-bold uppercase tracking-[0.12em] text-purple-100 transition-colors duration-300 hover:border-amber-300 hover:text-amber-300"
            >
              Ver no Google Maps
            </a>
          </div>
        </div>
      </motion.div>
    </div>
  </div>
);
